// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetLectureLessonStatesRequestModel from '../../model/get-lecture-lesson-states-request-model';
import LectureLessonStatusListResultModel from '../../model/lecture-lesson-status-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getLectureLessonStates(request: GetLectureLessonStatesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-lecture-lesson-states'] ?? 'LectureLessonStatus';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(LectureLessonStatusListResultModel.toModel(dto));
  },
});
